
import { defineComponent, ref, PropType } from 'vue'
import InputError from '@/components/ui/InputError.vue'
import VueMultiselect from 'vue-multiselect'

export default defineComponent({
    components: {
        VueMultiselect,
        InputError,
    },
    props: {
        isInvalid: {
            type: Boolean,
            default: false,
        },
        errors: {
            type: Array as PropType<string[]>,
            default: () => {
                return ['']
            },
        },
        options: {
            type: Array,
            required: true,
        },
    },
    inheritAttrs: false,
    setup() {
        const value = ref('')

        return {
            value,
        }
    },
})
